import { render, staticRenderFns } from "./MySandbox.vue?vue&type=template&id=7cca7bf3&"
import script from "./MySandbox.vue?vue&type=script&lang=js&"
export * from "./MySandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports